import { render, staticRenderFns } from "./ResetAdminPassword.vue?vue&type=template&id=3b93eb58&scoped=true&"
import script from "./ResetAdminPassword.vue?vue&type=script&lang=js&"
export * from "./ResetAdminPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b93eb58",
  null
  
)

export default component.exports